export const adjustableRates = ` /mortgage-rates/adjustable-rates/`
export const cashOutRefinanceLink = `/refinance/cash-out-refinance/`
export const conventionalLoansLink = `/home-loans/conventional-loans/`
export const debtConsolidation = `/resources/debt-consolidation/`
export const downPaymentAssistanceLink = `/home-loans/down-payment-assistance/`
export const fhaLoansLink = `/home-loans/fha-loans/`
export const fifteenYearFixedRateLink = `/mortgage-rates/15-year-fixed-rate/`
export const fixedRateLink = `/mortgage-rates/fixed-rate/`
export const fthLink = `/first-time-homebuyer/`
export const homeAffordabilityLink = `/home-affordability/`
export const homeEquityLink = `/home-equity/`
export const homeLoansLink = `/home-loans/`
export const homeownerHubLink = `/homeowner-hub/`
export const incomeQualificationLink = `/income-qualification/`
export const selfEmployedBorrowerLink = `/income-qualification/self-employed-borrower/`
export const investmentPropertyLoansLink = `/home-loans/investment-property-loans/`
export const jumboLoansLink = `/home-loans/jumbo-loans/`
export const mortgageProcessLink = `/mortgage-process/`
export const mortgageApprovalLink = `/mortgage-approval/`
export const mortgageRatesLink = `/mortgage-rates/`
export const rateTermRefinanceLink = `/refinance/rate-and-term-refinance/`
export const refinanceLink = `/refinance/`
export const refinanceProcess = `/refinance-process/`
export const secondHomeLink = `/home-loans/second-home/`
export const selfEmployedLoansLink = `/home-loans/self-employed-loans/`
export const usdaLoansLink = `/home-loans/usda-loans/`
export const thirtyYearFixedRateLink = `/mortgage-rates/30-year-fixed-rate/`
export const vaLoansLink = `/home-loans/va-loans/`
